<template>
    <div class="flex grow h-0 py-2">
        <div class="flex flex-col h-full w-full px-2">
            <card-form
                :callbacks="{ refreshData: refreshObjectCard, saveData: saveObjectCard, isDirty: null }"
                :meta="objectCardMeta.cardMeta"
                :to-remove-toolbar-items-names="['copy', 'edit', 'delete', 'settings']"
                :use-default-buttons="true"
                components-path="views/contracts/object/object-card/field-wrappers"
            />
        </div>
    </div>
</template>
<script setup>
import { useRoute } from 'vue-router';
import { insObjectCard } from '@/service/counteragent-service';
import CardForm from '@/components/card-component/card-form.vue';
import objectCardMeta from '@/views/contracts/object/object-card/object-card-meta';

const router = useRoute();

const refreshObjectCard = async () => objectCardMeta.emptyObjectCard;

const saveObjectCard = async data => {
    const response = await insObjectCard(data);
    if (response && response.result && response.success) {
        await router.push({
            name: 'ObjectCard',
            params: { id: response.data.kod_numobj },
        });
    }
    return response;
};
</script>
<script>
export default {
    name: 'object-card-new',
};
</script>
